import type { FilterValue, MultiSelectFilterValue, SelectOption } from '../types'

export const isEmptyFilterValue = (value: FilterValue) =>
  value === null || value === undefined || value === '' || (Array.isArray(value) && !value.length)

export const getMultiSelectFilterValue = (value: FilterValue): MultiSelectFilterValue => {
  if (Array.isArray(value)) {
    return value.map(String)
  }

  if (typeof value === 'string' || typeof value === 'number') {
    return [String(value)]
  }

  return []
}

export const getSelectOptionLabel = (value: string | number, options?: SelectOption[]) => {
  const option = options?.find((item) => String(item.value) === String(value))

  return option?.label || String(value)
}
